import React from 'react';
import CRUD from 'components/CRUD/Crud.component';
import { urlAdminExamen } from 'constants/urls';

const ExamenCrud = () => {
  const tableData = [
    {
      type: "inputDisabled",
      label: "Id",
      name: 'id',
      showOnCreate: false,
      showOnTable: true,
      tableProps: {
        sort: {
          sortColumnName: 'id',
          sortColumnNameDB: 'id',
        }
      },

    },
    {
      type: "input",
      name: "nombre",
      label: "Nombre",
      tableProps: {
        sort: {
          sortColumnName: 'nombre',
          sortColumnNameDB: 'nombre',
        }
      },
      validationOptions: {
        required: {
          value: true,
          message: 'El campo nombre es requerido',
        },
      },

    },
  ];

  const data = {
    tableData,
    urls: {
      createUrl: urlAdminExamen,
      updateUrl: urlAdminExamen,
      readUrl: urlAdminExamen,
      deleteUrl: urlAdminExamen,
    }
  }

  return (
    <CRUD data={data} />
  )
}

export default ExamenCrud;
